module.exports = __webpack_public_path__ + "static/media/0402.b05d3f12.png";